import { render } from "./question.vue?vue&type=template&id=04b4d9bf&scoped=true"
import script from "./question.vue?vue&type=script&lang=js"
export * from "./question.vue?vue&type=script&lang=js"

import "./question.vue?vue&type=style&index=0&id=04b4d9bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b4d9bf"]])

export default __exports__